import CustomerJourneyGeneralDetails from './CustomerJourneyGeneralDetails';

export default CustomerJourneyGeneralDetails;
